import "../../styles/all.css"
import "./services.css"
import { useTranslation } from 'react-i18next';
import Blogone from '../../img/blog_1.jpg'; 
import Blogtwo from '../../img/blog_2.jpg';
import Blogthree from '../../img/blog_3.jpg';
import Blogfour from '../../img/p-3.jpg';
import Blogfive from '../../img/p-5 (3).jpg';

const Services = () => {
  const { t } = useTranslation();

  return (
    <div className="services">
      <div className="continer">
        <h4>{t('our_services')}</h4>
        <h4>{t('trusted_projects')}</h4>
      </div>

      <div className="content">
        <div className="photos">
          <div className="services_card">
            <div className="image">
              <img src={Blogone} alt="Web Development" />
              <div className="text">
                <h5>{t('webser')}</h5>
                <p>{t('text_webser')}</p>
              </div>
            </div>
          </div>

          <div className="services_card">
            <div className="image">
              <img src={Blogtwo} alt="UI/UX Design" />
              <div className="text">
                <h5>{t('uiux')}</h5>
                <p>{t('text_uiux')}</p>
              </div>
            </div>
          </div>

          <div className="services_card">
            <div className="image">
              <img src={Blogthree} alt="Branding & Identity" />
              <div className="text">
                <h5>{t('branding')}</h5>
                <p>{t('text_branding')}</p>
              </div>
            </div>
          </div>

          <div className="services_card">
            <div className="image">
              <img src={Blogfour} alt="Technical Documentation" />
              <div className="text">
                <h5>{t('documentation')}</h5>
                <p>{t('text_documentation')}</p>
              </div>
            </div>
          </div>

          <div className="services_card">
            <div className="image">
              <img src={Blogfive} alt="Consulting & Strategy" />
              <div className="text">
                <h5>{t('consulting')}</h5>
                <p>{t('text_consulting')}</p>
              </div>
            </div>
          </div>

          <div className="services_card">
            <div className="image">
              <img src={Blogone} alt="CEO Founder & Manager" />
              <div className="text">
                <h5>{t('ceo')}</h5>
                <p>{t('text_ceo')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;